module.exports = __webpack_public_path__ + "img/Balkon08.c105d781.jpg";